/// <reference types="./migrateDecodeAndNormalizeEntityFields.d.ts" />
import { isComponentItemField, isRichTextComponentNode, notOk, ok, transformEntityFields, } from '@dossierhq/core';
import { applySchemaMigrationsToFields } from './applySchemaMigrationsToFields.js';
import { legacyDecodeEntityFields } from './legacyDecodeEntityFields.js';
export const ENCODE_VERSION_LEGACY = 0;
export const ENCODE_VERSION_AS_IS = 1; // version 0.4.2+: Used to encoding all content, old content is still encoded with version 0
export function migrateDecodeAndNormalizeAdminEntityFields(schema, entitySpec, path, entityFields) {
    return migrateDecodeAndNormalizeEntityFields(schema, schema, entitySpec, path, entityFields);
}
export function migrateDecodeAndNormalizePublishedEntityFields(schema, entitySpec, path, entityFields) {
    return migrateDecodeAndNormalizeEntityFields(schema, schema.toPublishedSchema(), entitySpec, path, entityFields);
}
function migrateDecodeAndNormalizeEntityFields(schema, decodeSchema, entitySpec, path, entityFields) {
    const migratedFieldValuesResult = applySchemaMigrationsToFields(schema, entitySpec.name, entityFields);
    if (migratedFieldValuesResult.isError())
        return migratedFieldValuesResult;
    const migratedFieldValues = migratedFieldValuesResult.value;
    switch (entityFields.encodeVersion) {
        case ENCODE_VERSION_LEGACY:
            return ok(legacyDecodeEntityFields(decodeSchema, entitySpec, migratedFieldValues));
        case ENCODE_VERSION_AS_IS: {
            const normalizeResult = transformEntityFields(decodeSchema, path, { info: { type: entitySpec.name }, fields: migratedFieldValues }, DECODE_TRANSFORMER);
            if (normalizeResult.isError())
                return normalizeResult;
            return ok(normalizeResult.value);
        }
        default:
            return notOk.Generic(`Unknown encode version ${entityFields.encodeVersion}`);
    }
}
const DECODE_TRANSFORMER = {
    transformField(_schema, _path, _fieldSpec, value) {
        return ok(value);
    },
    transformFieldItem(schema, _path, fieldSpec, value) {
        if (isComponentItemField(fieldSpec, value)) {
            const componentType = value?.type;
            if (componentType && !schema.getComponentTypeSpecification(componentType)) {
                // Could be that the component type was deleted or made adminOnly (when decoding published entities)
                return ok(null);
            }
        }
        return ok(value);
    },
    transformRichTextNode(schema, _path, _fieldSpec, node) {
        if (isRichTextComponentNode(node)) {
            const componentType = node.data.type;
            if (componentType && !schema.getComponentTypeSpecification(componentType)) {
                // Could be that the component type was deleted or made adminOnly (when decoding published entities)
                return ok(null);
            }
        }
        return ok(node);
    },
};
//# sourceMappingURL=migrateDecodeAndNormalizeEntityFields.js.map